import { inject } from '@angular/core'

import { Observable } from 'rxjs'

import { GuardCoordinatorService } from '@flowx/designer/shared/services/guard-coordinator.service'

// The settings page registers itself as an unsaved-changes source for as long as it is on screen,
// so leaving the route asks the same question — and runs the same discard — as every non-routing
// action that goes through confirmProceed(). No component handle needed.
export const applicationSettingsCanDeactivate = (): Observable<boolean> =>
  inject(GuardCoordinatorService).confirmProceed()
